// Deterministically pick a fake name from a fixed list based on an input string.

// List of common, believable fake names. Keep order stable for determinism.
const FAKE_NAMES = [
  "Michael Johnson",
  "Sarah Williams",
  "David Brown",
  "Jennifer Davis",
  "Christopher Miller",
  "Jessica Wilson",
  "Matthew Moore",
  "Amanda Taylor",
  "Daniel Anderson",
  "Melissa Thomas",
  "James Jackson",
  "Nicole White",
  "Robert Harris",
  "Michelle Martin",
  "William Thompson",
  "Emily Garcia",
  "John Martinez",
  "Ashley Robinson",
  "Joseph Clark",
  "Stephanie Rodriguez",
  "Andrew Lewis",
  "Lauren Lee",
  "Ryan Walker",
  "Megan Hall",
  "Joshua Allen",
  "Rachel Young",
  "Kevin King",
  "Kimberly Wright",
  "Brian Lopez",
  "Amanda Hill",
  "Justin Scott",
  "Samantha Green",
  "Eric Adams",
  "Lisa Baker",
  "Nathan Nelson",
  "Brittany Carter",
  "Adam Mitchell",
  "Jessica Perez",
  "Jason Roberts",
  "Nicole Turner",
  "Brandon Phillips",
  "Katherine Campbell",
  "Steven Parker",
  "Lauren Evans",
];

// djb2 string hash for stable, fast hashing
function djb2Hash(input) {
  let hash = 5381;
  for (let i = 0; i < input.length; i++) {
    hash = ((hash << 5) + hash) + input.charCodeAt(i); // hash * 33 + c
    // Convert to 32-bit integer
    hash |= 0;
  }
  return hash >>> 0; // unsigned
}

// Normalize input to reduce accidental differences
function normalizeKey(key) {
  if (key == null) return "";
  return String(key).trim().toLowerCase();
}

/**
 * Deterministically maps a key to a fake name from FAKE_NAMES.
 * @param {string} key - Any string identifier (e.g. email, id, etc.)
 * @returns {string} Stable fake name
 */
export function getStableFakeName(key, lastInitialOnly = false) {
  const normalized = normalizeKey(key);
  if (FAKE_NAMES.length === 0) return { first_name: "", last_name: "" };
  const hash = djb2Hash(normalized);
  const index = hash % FAKE_NAMES.length;
  const full = FAKE_NAMES[index];
  const parts = String(full).split(/\s+/);
  const firstname = parts[0] || "";
  const lastnameFull = parts.slice(1).join(" ") || "";
  const lastname = lastInitialOnly && lastnameFull
    ? `${lastnameFull[0].toUpperCase()}.`
    : lastnameFull;
  return { first_name:firstname, last_name:lastname };
}

export { FAKE_NAMES };

export default getStableFakeName;


